const REPORT_BASE = "/employee/admin/requests-received-web-report";
//===============================================================
export function getRequestsReceivedWebReportUrl(mode = "main") {
  return mode === "compare" ? `${REPORT_BASE}/compare` : REPORT_BASE;
}
//===============================================================
export function buildRequestsReceivedWebReportFormBody(filters, tableOptions = {}) {
  const {
    includeTableParams  = true, // include table params
    page                = 1,                // table page
    perPage             = 25,               // table per page
    agentSearch         = "",               // table agent search
  } = tableOptions;
  //===============================================================
  const body = new FormData();
  //===============================================================
  if (filters.startDate) {
    body.append("start_date", filters.startDate);
  }
  if (filters.endDate) {
    body.append("end_date", filters.endDate);
  }
  body.append("status_user", filters.statusUser);

  (filters.managerId || []).forEach((id, index) => {
    body.append(`manager_id[${index}]`, id);
  });
  (filters.adviserId || []).forEach((id, index) => {
    body.append(`adviser_id[${index}]`, id);
  });

  if (includeTableParams) {
    body.append("table_page", page);
    body.append("table_per_page", perPage);
    if (agentSearch) {
      body.append("table_agent_search", agentSearch);
    }
  }

  return body;
}
//===============================================================
export function applyRequestsReceivedWebTablePagination(payload, fallbackPerPage = 25) {
  const pagination = payload.table_pagination || {};

  return {
    tableData: payload.data || [],
    tablePagination: {
      page: pagination.current_page || 1,
      perPage: pagination.per_page || fallbackPerPage,
      total: pagination.total ?? (payload.data || []).length,
      lastPage: pagination.last_page || 1,
    },
  };
}
//===============================================================
export function todayYmd() {
  const d   = new Date(); // today date
  const m   = String(d.getMonth() + 1).padStart(2, "0"); // month
  const day = String(d.getDate()).padStart(2, "0"); // day
  return `${d.getFullYear()}-${m}-${day}`; // return today date in yyyy-mm-dd format
}
//===============================================================
export const REQUESTS_RECEIVED_WEB_REPORT_MODES = {
  ADMIN:          "admin", // admin mode
  SALES_MANAGER:  "sales_manager", // sales manager mode
};
//===============================================================